/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $Suggestions = {
    type: 'array',
    contains: {
        type: 'Suggestion',
    },
};